/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { AllShipmentsCalendarStats } from "./AllShipmentsCalendarStats";
import {
  AllShipmentsCalendarStatsFromJSON,
  AllShipmentsCalendarStatsFromJSONTyped,
  AllShipmentsCalendarStatsToJSON,
  AllShipmentsCalendarStatsToJSONTyped,
} from "./AllShipmentsCalendarStats";
import type { AllShipmentsWeekdayAverage } from "./AllShipmentsWeekdayAverage";
import {
  AllShipmentsWeekdayAverageFromJSON,
  AllShipmentsWeekdayAverageFromJSONTyped,
  AllShipmentsWeekdayAverageToJSON,
  AllShipmentsWeekdayAverageToJSONTyped,
} from "./AllShipmentsWeekdayAverage";
import type { AllShipmentsCalendarDay } from "./AllShipmentsCalendarDay";
import {
  AllShipmentsCalendarDayFromJSON,
  AllShipmentsCalendarDayFromJSONTyped,
  AllShipmentsCalendarDayToJSON,
  AllShipmentsCalendarDayToJSONTyped,
} from "./AllShipmentsCalendarDay";

/**
 *
 * @export
 * @interface AllShipmentsCalendar
 */
export interface AllShipmentsCalendar {
  /**
   *
   * @type {Array<AllShipmentsCalendarDay>}
   * @memberof AllShipmentsCalendar
   */
  days: Array<AllShipmentsCalendarDay>;
  /**
   *
   * @type {LocalDate}
   * @memberof AllShipmentsCalendar
   */
  from: LocalDate;
  /**
   *
   * @type {LocalDate}
   * @memberof AllShipmentsCalendar
   */
  to: LocalDate;
  /**
   *
   * @type {Array<AllShipmentsWeekdayAverage>}
   * @memberof AllShipmentsCalendar
   */
  weekdayAverages: Array<AllShipmentsWeekdayAverage>;
  /**
   *
   * @type {AllShipmentsCalendarStats}
   * @memberof AllShipmentsCalendar
   */
  stats: AllShipmentsCalendarStats;
}

/**
 * Check if a given object implements the AllShipmentsCalendar interface.
 */
export function instanceOfAllShipmentsCalendar(
  value: object,
): value is AllShipmentsCalendar {
  if (!("days" in value) || value["days"] === undefined) return false;
  if (!("from" in value) || value["from"] === undefined) return false;
  if (!("to" in value) || value["to"] === undefined) return false;
  if (!("weekdayAverages" in value) || value["weekdayAverages"] === undefined)
    return false;
  if (!("stats" in value) || value["stats"] === undefined) return false;
  return true;
}

export function AllShipmentsCalendarFromJSON(json: any): AllShipmentsCalendar {
  return AllShipmentsCalendarFromJSONTyped(json, false);
}

export function AllShipmentsCalendarFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsCalendar {
  if (json == null) {
    return json;
  }
  return {
    days: (json["days"] as Array<any>).map(AllShipmentsCalendarDayFromJSON),
    from: json["from"],
    to: json["to"],
    weekdayAverages: (json["weekdayAverages"] as Array<any>).map(
      AllShipmentsWeekdayAverageFromJSON,
    ),
    stats: AllShipmentsCalendarStatsFromJSON(json["stats"]),
  };
}

export function AllShipmentsCalendarToJSON(json: any): AllShipmentsCalendar {
  return AllShipmentsCalendarToJSONTyped(json, false);
}

export function AllShipmentsCalendarToJSONTyped(
  value?: AllShipmentsCalendar | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    days: (value["days"] as Array<any>).map(AllShipmentsCalendarDayToJSON),
    from: value["from"],
    to: value["to"],
    weekdayAverages: (value["weekdayAverages"] as Array<any>).map(
      AllShipmentsWeekdayAverageToJSON,
    ),
    stats: AllShipmentsCalendarStatsToJSON(value["stats"]),
  };
}
